import { render } from "./forgotPwd.vue?vue&type=template&id=453d122c&scoped=true"
import script from "./forgotPwd.vue?vue&type=script&lang=js"
export * from "./forgotPwd.vue?vue&type=script&lang=js"

import "./forgotPwd.vue?vue&type=style&index=0&id=453d122c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453d122c"]])

export default __exports__